<!-- <div class="root-container">
  <a href="" > Home </a>
  <a href=""> About Us </a>
  <a href=""> Contact Us </a>
  <a href=""> Careers </a>
  <a href="https://www.facebook.com/hytecpowerincorporated" target="_blank"> <i class="bi bi-facebook"></i> </a>
  <a href="https://www.youtube.com/user/hytecpowerinc"      target="_blank"> <i class="bi bi-youtube"></i> </a>
  <a href="https://www.linkedin.com/company/hytec-power"    target="_blank"> <i class="bi bi-linkedin"></i> </a>
  <a href="https://www.instagram.com/hytecpowerinc_official/?hl=en" target="_blank"> <i class="bi bi-instagram"></i> </a>
</div> -->

<div class="root-container">
  <div class="content container">
    <div class="row ">
      <!-- <div class="col-6 col-lg-4 footer-col">
        <div>
          <h3>GET SUPPORT</h3>
          <p><a href="#">Help Centre</a></p>
          <p><a href="#">Check Order Status</a></p>
          <p><a href="#">Return & Refund</a></p>
          <p><a href="#">Hytec Guarantee</a></p>
          <p><a href="#">Overseas Product</a></p>
          <p><a href="#">Contact Us</a></p>
          <p><a href="#">Report Abuse</a></p>
          <p><a href="#">Check Order Status</a></p>
        </div>
      </div> -->

      <div class="col-6 col-lg-4 footer-col">
        <div>
          <h3>ABOUT HPI Marketplace</h3>
          <!-- <p><a href="#">About Us</a></p> -->
          <!-- <p><a href="#">Hytec Blog</a></p> -->
          <!-- <p><a href="#">News Center</a></p> -->
          <!-- <p><a href="#">Careers</a></p> -->
          <p><a routerLink="/terms">Terms & Conditions</a></p>
          <!-- <p><a href="#">Privacy Policy</a></p> -->
          <!-- <p><a href="#">Terms of Use</a></p> -->
          <!-- <p><a href="#">Intellectual Property Protection</a></p> -->
        </div>
      </div>

      <div class="col-md-6 col-lg-4 footer-col">
        <div>
          <h3>FOLLOW US</h3>
          <div class="icons">
            <a href="https://www.facebook.com/hytecpowerincorporated" target="_blank"> <i class="bi bi-facebook"></i>
            </a>
            <a href="https://www.youtube.com/user/hytecpowerinc" target="_blank"> <i class="bi bi-youtube"></i> </a>
            <a href="https://www.linkedin.com/company/hytec-power" target="_blank"> <i class="bi bi-linkedin"></i> </a>
            <a href="https://www.instagram.com/hytecpowerinc_official/?hl=en" target="_blank"> <i
                class="bi bi-instagram"></i> </a>
          </div>

          <h3>REACH US</h3>
          <p><a href="#"><i class="bi bi-phone"></i> +63 939-907-0620 </a></p>
          <p><a href="#"><i class="bi bi-phone"></i> +63 917-814-5082 </a></p>
          <p><a href="#"><i class="bi bi-envelope"></i> ejssoliman&#64;hytecpower.com</a></p>
          <p><a href="#"><i class="bi bi-envelope"></i> mhemie.macero&#64;hytecpower.com</a></p>
          <!-- <p><a href="#"><i class="bi bi-globe"></i> hytecpower.com</a></p> -->
        </div>
      </div>

      <!-- <div class="col-md-6 col-lg-3 footer-col">
        <div class="app">
          <h3>DOWNLOAD E-HYTEC APP</h3>
          <div class="d-flex align-items-center" id="app">
            <div class="app-logo">
              <img src="assets/images/common/company_logo.png" alt="Hytec">
            </div>

            <div class="d-flex flex-column">
              <a href="#" class="btn-download">
                <div class="d-flex align-items-center justify-content-center">
                  <i class="bi bi-apple"></i>
                  <div class="d-flex flex-column px-2">
                    <small>Download on the</small>
                    <h3>App Store</h3>
                  </div>
                </div>
              </a>

              <a href="#" class="btn-download">
                <div class="d-flex align-items-center justify-content-center">
                  <i class="bi bi-google-play"></i>
                  <div class="d-flex flex-column px-2">
                    <small>Get it on</small>
                    <h3>Google Play</h3>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>

  <div class="copyright">
    &copy; Hytec Power Inc. {{ year }}. All Rights Reserved.
  </div>
</div>